import React from 'react'

const ProductAvailable = () => {
  return (
    <div>ProductAvailable</div>
  )
}

export default ProductAvailable